import React from 'react'
import ReactDOM from 'react-dom'
import App from './containers/App'
import WebFontLoader from 'webfontloader';
import { AppContainer } from 'react-hot-loader'
import {Route} from './components/Router'

import {default as StorelocatorAppContainer} from './containers/StorelocatorApp';
import {default as MarketingdisplaysAppContainer} from './containers/MarketingdisplaysApp';
import {default as DashboardAppContainer} from './containers/DashboardApp';
import {default as BookmakerAppContainer} from './containers/BookmakerApp';
import {default as SystemAppContainer} from './containers/SystemApp';
import {default as MobileappContainer} from './containers/MobileappApp';
import {default as EventsContainer} from './containers/EventsContainer';
import {default as CanvasContainer} from './containers/CanvasContainer';
import {default as StaticfilesContainer} from './containers/StaticfilesContainer';
import {default as StoriesContainer} from './containers/StoriesContainer';
import {default as RmgContainer} from './containers/RmgContainer';
import {ImagetoolContainer} from './containers/ImagetoolContainer';

WebFontLoader.load({
  google: {
    families: ['Roboto:300,400,500,700', 'Material Icons'],
  },
});

if (__DEV__) {
	console.log('Dev mode');
	if (module.hot)
		module.hot.accept()
}

/*
 * Routes:
 * 			<Route path="/image/:id/:channel/:publicationIdx" exact component={ExampleAppContainer} />	
			<Route path="/image/:id/:channel" exact component={ImageEditContainer} />	
	    	<Route path="/image/:id" exact component={ImageDetailsContainer} />	
	    	<Route path="/schedule/:id" exact component={SchedulesContainer} />	
 */

const routes = <AppContainer>
	<App>
		<div>
            <Route path="/" exact={true} component={DashboardAppContainer} />
			<Route path="/storelocator/*" component={StorelocatorAppContainer} />
            <Route path="/displays/*" component={MarketingdisplaysAppContainer} />
            <Route path="/bookmaker/*" component={BookmakerAppContainer} />
            <Route path="/app/*" component={MobileappContainer} />
            <Route path="/system/*" component={SystemAppContainer} />
            <Route path="/events/*" component={EventsContainer} />
            <Route path="/canvas/*" component={CanvasContainer} />
            <Route path="/staticfiles/*" component={StaticfilesContainer} />
            <Route path="/ip/*" component={ImagetoolContainer} />
            <Route path="/stories/*" component={StoriesContainer} />
            <Route path="/rmg/*" component={RmgContainer} />
		</div>
	</App>
</AppContainer>

ReactDOM.render((routes), document.getElementById( 'root' ) )